
import { buildAssetUri } from '~/utils/mixins';
import TruncateParagraph from '../atom/TruncateParagraph.vue';
import { getImageUrl } from '~/utils/behavior/imageUrl';

export default {
  name: 'GuideSearchResultCard',
  components: {
    TruncateParagraph,
  },
  mixins: [buildAssetUri],
  props: {
    guide: {
      type: Object,
      required: true,
    },
    cardWidth: {
      type: Number,
      default: null,
    },
    thumbnailWidth: {
      type: Number,
      default: 120,
    },
    thumbnailFormat: {
      type: String,
      required: true,
    },
  },
  computed: {
    readTime() {
      return this.guide.readTime + ' min';
    },
    thumbnailUri() {
      const baseUri = this.buildAssetUri(this.guide.thumbnailUri);

      return getImageUrl(baseUri, this.thumbnailFormat);
    },
  },
};
